import { fetchHotels } from '../api/fetchHotels';
import type { HotelSelectItem, HotelSelectSubheader, HotelSelectItemData } from './types';

export const useFetchHotels = () => {
    const initializeHotels = async (groupId: string): Promise<HotelSelectItem[]> => {
        const data = await fetchHotels(groupId);

        const groupJapaneseName = data.group?.group_japanese_name ?? '';
        const groupEnglishName = data.group?.group_english_name ?? '';

        return (data.group?.areas ?? []).flatMap((area): HotelSelectItem[] => [
            {
                type: 'subheader',
                title: area.area_japanese_name ?? '',
                japaneseName: area.area_japanese_name ?? '',
                englishName: area.area_english_name ?? '',
            } satisfies HotelSelectSubheader,
            ...(area.hotels ?? []).map(
                (hotel): HotelSelectItemData => ({
                    type: 'item',
                    title: hotel.japanese_name,
                    japaneseName: hotel.japanese_name,
                    englishName: hotel.english_name,
                    value: hotel.id,
                    japaneseAddress: hotel.japanese_address,
                    englishAddress: hotel.english_address,
                    latitude: hotel.latitude.toString(),
                    longitude: hotel.longitude.toString(),
                    groupJapaneseName,
                    groupEnglishName,
                })
            ),
        ]);
    };

    return {
        initializeHotels,
    };
};
